export enum SubmissionCommunicationStatus {
  submitted = "Submitted",
  accepted = "Accepted",
  rejected = "Rejected",
  notSubmitted = "Not Submitted",
  inReview = "In Review",
  voided = "Voided",
  processingSubmission = "Processing Submission",
  failed = "Failed",
}
